import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut, User } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0A14]/80 border-b border-violet-500/20">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to={user ? "/home" : "/"} data-testid="logo-link" className="flex items-center gap-3 group">
          <Sparkles className="w-7 h-7 text-[#A78BFA] group-hover:text-[#2DD4BF] transition-colors duration-200" />
          <span className="font-head font-900 text-xl text-slate-100 tracking-tight">
            INNER<span className="text-[#A78BFA]">ARCADE</span>
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <Link to="/home" data-testid="nav-home" className="font-arcade text-lg text-slate-300 hover:text-[#2DD4BF] transition-colors duration-200 hidden sm:block">HOME</Link>
              <Link to="/mindful" data-testid="nav-mindful" className="font-arcade text-lg text-slate-300 hover:text-[#A78BFA] transition-colors duration-200 hidden sm:block">GAMES</Link>
              <Link to="/alignment" data-testid="nav-alignment" className="font-arcade text-lg text-slate-300 hover:text-[#A78BFA] transition-colors duration-200 hidden sm:block">ALIGN</Link>
              <Link to="/journey" data-testid="nav-journey" className="font-arcade text-lg text-slate-300 hover:text-[#F5C842] transition-colors duration-200 hidden sm:block">JOURNEY</Link>
              <Link to="/market" data-testid="nav-market" className="font-arcade text-lg text-slate-300 hover:text-[#2DD4BF] transition-colors duration-200 hidden sm:block">MARKET</Link>
              <Link to="/games" data-testid="nav-games" className="font-arcade text-lg text-slate-300 hover:text-[#00F0FF] transition-colors duration-200 hidden md:block">RETRO</Link>
              <Link to="/dashboard" data-testid="nav-dashboard" className="flex items-center gap-2 px-3 py-1.5 border border-violet-500/20 bg-[#11111A] hover:border-violet-400/50 transition-colors duration-200">
                <User className="w-4 h-4 text-[#F5C842]" />
                <span className="text-sm text-slate-300 max-w-[120px] truncate">{user.name}</span>
              </Link>
              <button
                data-testid="logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                className="p-2 border border-[#FF006E]/40 text-[#FF006E] hover:bg-[#FF006E] hover:text-black transition-colors duration-200"
                aria-label="Logout"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="header-signin-btn"
              className="font-arcade text-lg px-5 py-2 bg-[#A78BFA] text-black border border-[#A78BFA] hover:shadow-[4px_4px_0px_#2DD4BF] hover:-translate-x-0.5 hover:-translate-y-0.5 transition-transform duration-200"
            >
              BEGIN
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
